const localizers = {
  'loading.msg': () => `Indlæser...`,
  'SASServer.genericError.msg': () => `Der kan ikke oprettes forbindelse til serveren.`,
  'SASReport.genericError.msg': () => `Den valgte rapport kunne ikke indlæses.`,
  'SASReportImage.genericError.msg': () => `Rapportbilledet kunne ikke indlæses.`,
  'SASReportImage.imageNotSupported.msg': () => `Billeder understøttes ikke for denne rapports indholdstype.`,
}
export default localizers;
